function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:3px;fill:none}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_282",
  d: "M0 0L0 15.059",
  className: "prefix__cls-2",
  "data-name": "Line 282",
  transform: "translate(21.887 18.673)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_283",
  d: "M0 0L0 15.059",
  className: "prefix__cls-2",
  "data-name": "Line 283",
  transform: "translate(68.27 18.673)"
});

var SvgClothes01Dresser = function SvgClothes01Dresser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93.357,
    height: 88.937,
    viewBox: "0 0 93.357 88.937",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "prefix__clothes-01",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_301",
    d: "M1.7 37.836s3.414 4.016 6.827 5.421a23.928 23.928 0 0 0 9.036 4.016l5.823-10.441-2.41 47.587a69.821 69.821 0 0 0 25.9 4.819 71.6 71.6 0 0 0 26.1-4.819l-2.811-48.39 6.024 11.043s6.225-1.807 9.237-4.217c3.012-2.209 6.626-5.02 6.626-5.02S77 10.729 73.183 7.517c-3.614-.2-15.26-4.217-15.26-4.217s-2.812 10.642-11.044 11.445C38.245 14.343 35.433 3.5 35.433 3.5s-12.65 3.815-15.26 3.815C14.551 13.139 1.7 37.836 1.7 37.836z",
    "data-name": "Path 301",
    transform: "translate(-1.7 -3.3)",
    style: {
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "transparent"
    }
  }), _ref3, _ref4));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClothes01Dresser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clothes-01-dresser.73fb8da8.svg";
export { ForwardRef as ReactComponent };